import classnames from 'classnames';
import { map } from 'lodash-es';
import React from 'react';
import { formatMoney as formatMoneyHelper } from '../common/utils';
import Button from './Button';
export function PlansTable({ plans, selectedPlanId, recommendedPlanId, planActionLabel, planCallback, shouldDisablePlan }) {
    const formatNumber = (value) => {
        if (value === 0) {
            return '-';
        }
        return value.toString();
    };
    const formatMoney = (value) => {
        if (value === 0) {
            return '-';
        }
        return `${formatMoneyHelper(value)} ea.`;
    };
    return (React.createElement("div", { className: 'plans-table' }, map(plans, plan => (React.createElement("div", { key: plan.id, className: classnames('plans-table__column', {
            'plans-table__column--selected': selectedPlanId === plan.id,
        }) },
        React.createElement("div", { className: classnames('plans-table__column-header', { 'plans-table__column-header--most-popular': plan.id === recommendedPlanId }) },
            plan.id === recommendedPlanId &&
                React.createElement("div", { className: "recommended-badge" }, "Recommended"),
            React.createElement("h2", null, plan.name),
            React.createElement("div", { className: "plan-price" },
                React.createElement("div", { className: "plan-price__value" },
                    React.createElement("span", null,
                        "$",
                        plan.price.split('.')[0],
                        "."),
                    React.createElement("span", { className: "plan-price__fraction" }, plan.price.split('.')[1])),
                React.createElement("span", null, "per month"))),
        React.createElement("div", { className: 'plans-table__column-cell' },
            React.createElement(Button, { className: "plan-table__select-button", variant: selectedPlanId !== plan.id ? 'marketing-border' : 'marketing-solid', onClick: () => planCallback(plan), disabled: shouldDisablePlan ? shouldDisablePlan(plan) : false }, planActionLabel(plan)),
            React.createElement("div", { className: 'plans-table__column-cell-number' }, formatNumber(plan.total_local_numbers)),
            React.createElement("div", { className: 'plans-table__column-cell-text' }, "Local Numbers")),
        React.createElement("div", { className: 'plans-table__column-cell' },
            React.createElement("div", { className: 'plans-table__column-cell-number' }, formatNumber(plan.total_local_minutes)),
            React.createElement("div", { className: 'plans-table__column-cell-text' }, "Local Minutes")),
        React.createElement("div", { className: 'plans-table__column-cell' },
            React.createElement("div", { className: 'plans-table__column-cell-number' }, formatNumber(plan.total_tollfree_numbers)),
            React.createElement("div", { className: 'plans-table__column-cell-text' }, "Toll-Free Numbers")),
        React.createElement("div", { className: 'plans-table__column-cell' },
            React.createElement("div", { className: 'plans-table__column-cell-number' }, formatNumber(plan.total_tollfree_minutes)),
            React.createElement("div", { className: 'plans-table__column-cell-text' }, "Toll-Free Minutes")),
        React.createElement("div", { className: 'plans-table__column-cell plans-table__column-cell--dark' }, "Additional Usage"),
        React.createElement("div", { className: 'plans-table__column-cell plans-table__column-cell--hidden' }),
        React.createElement("div", { className: 'plans-table__column-cell' },
            React.createElement("div", { className: 'plans-table__column-cell-number' }, formatMoney(parseFloat(plan.local_numbers_cost))),
            React.createElement("div", { className: 'plans-table__column-cell-text' }, "Local Numbers")),
        React.createElement("div", { className: 'plans-table__column-cell' },
            React.createElement("div", { className: 'plans-table__column-cell-number' }, formatMoney(parseFloat(plan.local_minutes_cost))),
            React.createElement("div", { className: 'plans-table__column-cell-text' }, "Local Minutes")),
        React.createElement("div", { className: 'plans-table__column-cell' },
            React.createElement("div", { className: 'plans-table__column-cell-number' }, formatMoney(parseFloat(plan.tollfree_numbers_cost))),
            React.createElement("div", { className: 'plans-table__column-cell-text' }, "Toll-Free Numbers")),
        React.createElement("div", { className: 'plans-table__column-cell' },
            React.createElement("div", { className: 'plans-table__column-cell-number' }, formatMoney(parseFloat(plan.tollfree_minutes_cost))),
            React.createElement("div", { className: 'plans-table__column-cell-text' }, "Toll-Free Minutes")))))));
}
